import React, { memo, useMemo } from 'react';

import moment from 'moment';
import { IoNotificationsOffSharp } from 'react-icons/io5';

import RenderMentionText from '../../../components/RenderMentionText/RenderMentionText';
import { useAppSelector } from '../../../shared/hooks';
import { getDMUser } from '../../../shared/utils';
import { ICommunityMessageRoom } from '../../../types/communityMessagesTypes';
import CreatorTag from './CreatorTag';

type Props = {
  roomData: ICommunityMessageRoom;
  onClick: () => void;
};

const CommunityRoomCard: React.FC<Props> = ({ roomData, onClick }) => {
  const { channel, lastMessage, unreadCount } = roomData;
  const { hostMetadata } = useAppSelector((state) => state?.app);

  const dmUser = useMemo(
    () =>
      roomData?.roomType === 'dm' && roomData?._id ? getDMUser(roomData) : null,
    [roomData],
  );

  const randerAvatar = useMemo(() => {
    if (roomData?.roomType === 'dm') {
      return (
        <img
          src={
            dmUser?.profilePicUrl ||
            'https://tagmango.com/staticassets/avatar-placeholder.png-1612857612139.png'
          }
          alt=""
        />
      );
    }
    if (
      roomData?.channel?.communityProfilePicture &&
      roomData?.channel?.communityProfilePictureType === 'emoji'
    ) {
      return (
        <div className="message-card_user-wrapper_avatar_emoji">
          {channel?.communityProfilePicture}
        </div>
      );
    }
    return <img src={channel?.communityProfilePicture} alt="" />;
  }, [
    channel?.communityProfilePicture,
    dmUser?.profilePicUrl,
    roomData?.channel?.communityProfilePicture,
    roomData?.channel?.communityProfilePictureType,
    roomData?.roomType,
  ]);

  return (
    <div className="message-card" key={roomData?._id}>
      <div className="message-card_user-wrapper" onClick={() => onClick()}>
        <div
          className={`message-card_user-wrapper_avatar ${
            unreadCount ? 'message-card_user-wrapper_avatar-active' : ''
          }`}>
          {randerAvatar}
        </div>
        <div className="message-card_user-wrapper_name">
          <div style={{ display: 'flex' }}>
            <h4>{dmUser?.name || channel?.name}</h4>
            {hostMetadata?.creator?._id === dmUser?._id ? <CreatorTag /> : null}
          </div>

          <p>
            <RenderMentionText
              whiteSpaceNowrap
              string={lastMessage?.message || ''}
            />
          </p>
        </div>
        <div className="message-card_user-wrapper_time">
          <p className="message-card_user-wrapper_time_number">
            {moment(lastMessage?.createdAt).format('hh:mm A')}
          </p>
          {unreadCount || roomData?.messageNotificationsMuted ? (
            <div className="message-card_user-wrapper_time_unread-wrapper">
              {unreadCount ? (
                <div className="message-card_user-wrapper_time_unread-wrapper_unread">
                  <p className="message-card_user-wrapper_time_unread-wrapper_unread_count">
                    {unreadCount}
                  </p>
                </div>
              ) : null}
              {roomData?.messageNotificationsMuted ? (
                <IoNotificationsOffSharp />
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default memo(CommunityRoomCard);
